module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm6_m.1bd97aca42b0630d4a349237891d40db.png";